// 项目自定义指令
const userDefinedDirective = {
  install: function(Vue) {
    // 延迟显示节点
    Vue.directive('delayshow', {
      bind: function(el, obj, VNode) {
        if(obj.value != true) return;
        el.style.display = 'none'
      },
      componentUpdated: function(el, obj, VNode) {
        if(obj.value != true) return;
        VNode.context.$nextTick(() => {
          el.style.display = 'block'
        })
      }
    });
  }
};
export default userDefinedDirective;



// WEBPACK FOOTER //
// ./src/utils/userDefinedDirective.js